import { RootState } from "../store/store"

export function selectLoginUser({ user }: RootState) {
    return user.user
}
